export const widget = document.querySelector('#faq-widget');
export const widgetClose = document.querySelector('#faq-widget-close');

export const searchInput = document.querySelector('input[name="searchword"]');

export const backButton = document.getElementById('back-button')
export const lcWindow = document.getElementById('lc')
export const connectionMessage = document.getElementById('connection-message')
export const lcWindowMinimized = document.getElementById('lc-minimized')
export const footer = document.getElementById('footer')
export const startChatButton = document.getElementById('start-chat-button')
export const sendButton = document.getElementById('send-button')
export const textareaWrapper = document.getElementById('textarea-wrapper')
export const input = document.getElementById('message-input')
export const minimizeButton = document.getElementById('minimize')

export const presurveyForm = document.getElementById('chat-form')
export const presurveyScroller = document.getElementById('pre-survey-scroller')

export const presurveyName = document.getElementById('presurvey-name');
export const presurveyNameContainer = document.getElementById('presurvey-name-container');
export const presurveyEmail = document.getElementById('presurvey-email');
export const presurveyEmailContainer = document.getElementById('presurvey-email-container');
export const presurveyPhone = document.getElementById('presurvey-phone');
export const presurveyPhoneContainer = document.getElementById('presurvey-phone-container');
export const presurveyQuestion = document.getElementById('presurvey-question');
export const presurveyQuestionContainer = document.getElementById('presurvey-question-container');
export const presurveyConditions = document.getElementById('presurvey-conditions');
export const presurveyConditionsContainer = document.getElementById('presurvey-conditions-container');
export const presurveyInfoContainer = document.getElementById('presurvey-info-container');
export const presurveyInfo = document.getElementById('presurvey-info');

export const presurvey = document.getElementById('pre-survey');

export const agentsOfflineInfo = document.getElementById('agents-offline-info');
export const agentsOfflinePresurveyInfo = document.getElementById('agents-offline-presurvey-info');

export const offlineSection = document.getElementById('offline-section');
export const offlineSectionOffline = document.getElementById('offline-section-offline');
export const offlineSectionOccupied = document.getElementById('offline-section-occupied');

export const offlineSectionScroller = document.getElementById('offline-section-scroller');
export const offlineForm = document.getElementById('offline-form');
export const offlineFormInfo = offlineForm.querySelector('.form__info');
export const offlineFormConditions = document.querySelector('#offline-conditions');
export const offlineFormConditionsTooltip = document.querySelector('#offline-conditions-tooltip');

export const offlineFormCheckboxTemplate = document.getElementById('ticket-form-checkbox-template');

export const offlineName = document.getElementById('offline-name');
export const offlineNameContainer = document.getElementById('offline-name-container');
export const offlineEmail = document.getElementById('offline-email');
export const offlineEmailContainer = document.getElementById('offline-email-container');
export const offlinePhone = document.getElementById('offline-phone');
export const offlinePhoneContainer = document.getElementById('offline-phone-container');
export const offlineSubject = document.getElementById('offline-subject');
export const offlineSubjectContainer = document.getElementById('offline-subject-container');
export const offlineQuestion = document.getElementById('offline-question');
export const offlineQuestionContainer = document.getElementById('offline-question-container');

export const callbackForm = document.querySelector('#callback-form');
export const callbackFormFullname = callbackForm.querySelector('#callback-form-full-name');
export const callbackFormEmail = callbackForm.querySelector('#callback-form-email');
export const callbackFormPhone = callbackForm.querySelector('#callback-form-phone');
export const callbackFormTopic = callbackForm.querySelector('#callback-form-topic');
export const callbackFormConditions = callbackForm.querySelector('#callback-form-conditions');
export const callbackFormDay = callbackForm.querySelector('#callback-form-day');
export const callbackFormTimeslot = callbackForm.querySelector('#callback-form-timeslot');

export const callbackFormConditionsError = callbackForm.querySelector('#callback-form-conditions-tooltip .error');
export const callbackFormError = callbackForm.querySelector('#callback-form-error');

export const callbackFormLoader = callbackForm.querySelector('#callback-step-2');
export const callbackFormStep1 = callbackForm.querySelector('#callback-step-1');
export const callbackFormStep2 = callbackFormLoader;
export const callbackFormStep3 = callbackForm.querySelector('#callback-step-3');
export const callbackFormStep4 = callbackFormLoader;
export const callbackFormStep5 = callbackForm.querySelector('#callback-step-5');

export const callbackFormBackButton = callbackForm.querySelector('#callback-back-button');

export const offlineMessageSent = document.getElementById('offline-message-sent');


export const chatFinishedSection = document.getElementById('chat-finished-section');


export const logoLoader = `
<svg class="resizable-svg" viewBox="0 0 72 99" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
        .rectangle-bar {
            fill: #5CA7F5;
        }

        .circle-background {
            fill: transparent;
        }

        .letter-c {
            fill: #31374F;
        }
    </style>
    <rect y="81" class="rectangle-bar" width="72" height="18" />
    <g class="circle">
    <rect class="circle-background" width="72" height="72" />
    <path class="letter-c" d="M49.8,45c-2.9,4.5-8,7.5-13.8,7.5c-9.1,0-16.5-7.4-16.5-16.5c0-9.1,7.4-16.5,16.5-16.5c5.8,0,10.9,3,13.8,7.5
        h21C66.9,11.5,52.8,0,36,0C16.1,0,0,16.1,0,36s16.1,36,36,36c16.8,0,30.9-11.5,34.9-27H49.8z" shape-rendering="geometricPrecision"
    />
    </g>
</svg>
`

export const parpLogoLoader = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1" y1="-1" x2="20.9383" y2="-1"
          transform="matrix(0.706822 0.707391 -0.706822 0.707392 8.03955 9.2674)" stroke="white"
          stroke-width="2" stroke-linecap="round"/>
    <line x1="1" y1="-1" x2="20.9383" y2="-1"
          transform="matrix(0.706822 -0.707392 0.706822 0.707392 9.41846 24.9263)"
          stroke="white"
          stroke-width="2" stroke-linecap="round"/>
</svg>`;


// WEBPACK FOOTER //
// ./src/DOMElements.js
